"use strict";

/**
 * This file exports the base schema which we will assume exists if nothing in firebase overrides it.
 *
 */
export default {
    customQuestions: {
        rsvp: {
            title: "RSVP",
            question: "Will you be attending our wedding?",
            type : "application/vnd.joylife.question.multiplechoice",
            choices: {
                "attending": {
                    store: {v: true},
                    display: {v: "Attending"},
                    sortKey: "0"
                },
                "notAttending": {
                    store: {v: false},
                    display: {v: "Not Attending"},
                    sortKey: "1"
                }
            }
        },
        address: {
            title: "Mailing Address",
            question: "What is your mailing address?",
            type : "text/plain",
            parent: "isRSVPAttending-address",
            askPlusOnes: false
        },
        diet: {
            title: "Dietary Restrictions",
            question: "Do you have any dietary restrictions?",
            type : "text/plain",
            parent: "isRSVPAttending-diet"
        },
        hotel: {
            title: "Hotel Accommodations",
            question: "Do you need help finding hotel accommodations?",
            type : "application/vnd.joylife.question.multiplechoice",
            choices: {
                "yes": {
                    store: {v: true},
                    display: {v: "Yes, I could use help finding a hotel."},
                    sortKey: "0"
                },
                "no": {
                    store: {v: false},
                    display: {v: "No, I already have a place to stay."},
                    sortKey: "1"
                },
                "maybe": {
                    store: {v: "maybe"},
                    display: {v: "Maybe"},
                    sortKey: "2"
                }
            },
            parent: "isRSVPAttending-hotel",
            askPlusOnes: false
        },
        notes: {
            title: "Other notes",
            question: "Do you have any additional notes?",
            type : "text/plain"
        },
        weddingTeam: {
            title: "Who do you know?",
            question: "Are you a friend or family of...?",
            type: "application/vnd.joylife.question.multiplechoice",
            choices: {
                owner: {
                    display: {v: "ownerName.first;"},
                    sortKey: "a-100"
                },
                fiancee: {
                    display: {v: "fianceeName.first;"},
                    sortKey: "a-200"
                },
                both: {
                    display: {v: "Both"},
                    sortKey: "a-300"
                }
            }
        },
        funFact: {
            title: "How do you know...",
            question: "Share how you know the couple, wish them well or some wisdom for the future!",
            type : "text/plain"
        },
        relationshipStatus: {
            title: "Relationship Status",
            question: "Are you single and ready to mingle, or happily off the market?",
            type: "application/vnd.joylife.question.multiplechoice",
            choices: {
                single: {
                    display: {v: "Single"},
                    sortKey: "a-100"
                },
                relationship: {
                    display: {v: "In a Relationship"},
                    sortKey: "a-200"
                },
                engaged: {
                    display: {v: "Engaged"},
                    sortKey: "a-300"
                },
                married: {
                    display: {v: "Married"},
                    sortKey: "a-400"
                },
                ask: {
                    display: {v: "Ask Me"},
                    sortKey: "a-500"
                },
                wink: {
                    display: {v: "Wink Wink :)"},
                    sortKey: "a-600"
                },
                default: {
                    display: {v: "Prefer not to say"},
                    store: {"_": true},
                    sortKey: "z-900"
                }
            }
        }
    },
    overrides: {
        //rsvp: true,
        //address: true,
        diet: false,
        hotel: false,
        notes: false,
        //weddingTeam: true,
        //funFact: true,
        //relationshipStatus: true
    },
    sortKeys: {
        rsvp: "a-100",
        address: "a-100-100",
        diet: "a-100-200",
        hotel: "a-100-300",
        notes: "z-100",
        weddingTeam: "z-200",
        funFact: "z-300",
        relationshipStatus: "z-400"
    }
};
